/* eslint-disable no-shadow */
import { Box, Button } from '@mui/material'
import React from 'react'
import { Timestamp } from '@firebase/firestore'
import CustomTextField from '../../../../components/forms/custom-elements/CustomTextField'
import CustomFormLabel from '../../../../components/forms/custom-elements/CustomFormLabel'
import { useUnits } from '../../../../utils/context/units/UnitsContext'

export default function UnitForm() {
  const unitNameRef = React.useRef()
  const [unitName, setUnitName] = React.useState('');

  const { createUnits, loading} = useUnits();

  const handleSubmit = async (e, unitNameRef, setUnitName) => {
    e.preventDefault();

    // Disallow multiple clicks
    if (loading) {
      return;
    }

    // Check for empty input
    if (unitNameRef.current.value === '') {
      return;
    }

    // Add the value
    const newUnit = {
      unitName: unitNameRef.current.value,
      dateCreated: Timestamp.fromDate(new Date()),
      unitId: '',
    };

    await createUnits(newUnit);

    // Clear the input field
    setUnitName('');

  };

  return (
    <Box>
      <CustomFormLabel htmlFor="unitName">Unit Name</CustomFormLabel>
      <CustomTextField
        id="unitName"
        variant="outlined"
        fullWidth
        size="small"
        label="Enter unit name"
        inputRef={unitNameRef}
        helperText="Example: Meter (m), Kilogram (kg), etc."
        value={unitName}
        onChange={(e) => setUnitName(e.target.value)}
      />

      <Button
        onClick={
          (e) => {
            handleSubmit(e, unitNameRef, setUnitName)
          }
        }
        variant="contained"
        color="primary"
        size="small"
        sx={{ mt: 2 }}
        disabled={loading}
      >
        {loading ? 'Loading...' : 'Add Unit'}
      </Button>
    </Box>
  );
}
